<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>智能短信</el-breadcrumb-item>
            <el-breadcrumb-item>短信任务</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="10">
          <el-row :gutter="2">
            <el-col :span="6">
              <el-input size="small" clearable v-model="searchName" placeholder="请输入标题"></el-input>
            </el-col>
            <el-col :span="6">
              <el-input size="small" clearable v-model="searchNum" placeholder="请输入目标号码"></el-input>
            </el-col>
            <el-col :span="2">
              <el-button size="small" clearable icon="el-icon-search" @click="Search"></el-button>
            </el-col>
            <el-col :span="2">
              <el-button size="small" clearable icon="el-icon-plus" @click="AddTask"></el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
            </el-col>
            <el-col :span="6">
              <el-tag style="margin-left:6px">剩余{{ smsCount }}条</el-tag>
              <!-- 剩余 <span style="color:red;">{{smsCount}}</span> 条 -->
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="14">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageIndex"
            :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount" style="float:right"></el-pagination>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="SmsTaskList" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="Title" label="标题"></el-table-column>
            <el-table-column prop="AddUserName" label="添加人"></el-table-column>
            <el-table-column prop="Type" :formatter="SmsTaskTypeFormat" label="类型"></el-table-column>
            <el-table-column prop="IsRepeat" :formatter="isRepeatFormat" label="是否重复"></el-table-column>
            <el-table-column prop="TaskBeginTime" label="任务开始时间"></el-table-column>
            <el-table-column prop="SucessCount" label="成功数量"></el-table-column>
            <el-table-column prop="Status" :formatter="statusFormat" label="状态"></el-table-column>
            <el-table-column label="详情">
              <template slot-scope="scope">
                <el-tooltip placement="left" effect="light">
                  <div slot="content">
                    标题：{{ scope.row.Title }}
                    <br />
                    添加人：{{ scope.row.AddUserName }}
                    <br />目标号码：
                    <div style="width:200px">{{ scope.row.AppointNumbers }}</div>
                    <br />内容：
                    <div style="width:200px">{{ scope.row.Content }}</div>
                    <br />成功号码：
                    <div style="width:200px">{{ scope.row.SuccessNumbers }}</div>
                    <br />
                    任务开始时间：{{ scope.row.TaskBeginTime }}
                    <br />
                    成功数量：{{ scope.row.SucessCount }}
                    <br />
                    返回信息：{{ scope.row.ErrorMsg }}
                    <br />
                    任务状态：{{ statusFormatter(scope.row.Status) }}
                    <br />
                  </div>
                  <el-button type="text">详情</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="scope.row.Status == 0" @click="UpdateTask(scope.row)" type="text">编辑</el-button>
                <el-button v-if="scope.row.Status == 0" @click="doTask(scope.row)" type="text">执行任务</el-button>
                <el-button v-if="scope.row.Status == 1 || scope.row.Status == 2" @click="doTasks(scope.row)"
                  type="text">复制</el-button>
                <el-popconfirm title="确定删除此条信息吗？" @confirm="DeleteTask(scope.row)">
                  <el-button type="text" slot="reference">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-dialog width="50%" :title="dialogTitle" :visible.sync="dialogVisible" top="10px">
        <el-form :model="SmsTask" ref="taskForm" :rules="taskRules">
          <el-form-item label="任务标题" :label-width="formLabelWidth" prop="Title">
            <el-input v-model="SmsTask.Title" autocomplete="off" placeholder="请输入任务标题"></el-input>
          </el-form-item>
          <el-form-item label="目标号码" :label-width="formLabelWidth" prop="AppointNumbers">
            <el-input v-model="SmsTask.AppointNumbers" autocomplete="off" placeholder="请输入目标手机号码，多个请用英文逗号隔开"></el-input>
          </el-form-item>
          <el-form-item label="内容模板" :label-width="formLabelWidth" prop="Content">
            <el-input v-model="SmsTask.Content" autocomplete="off" placeholder="请输入发送内容"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="OperSMSTask">保存</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
import {
  GetSmsTaskPage,
  GetSingleSmsTask,
  UpdateSmsTask,
  AddSmsTask,
  DoTask,
  GetSmsCount
} from "../../until/ZeusApiSDK/Logic/SMSTaskLogic";
import {
  GetKnowledgeContentDescry,
  EncryptContent
} from "../../until/ZeusApiSDK/Logic/WikiLogic";
import {
  GetCurrentUserInfo,
  GetNewGuid
} from "../../until/ZeusApiSDK/Logic/HomeLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate.js";
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";
export default {
  data() {
    return {
      searchName: "",
      searchNum: "",
      smsCount: '无限',
      SmsTaskList: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      childrenOverdrafts: [],
      dialogVisible: false,
      dialogTitle: "添加任务",
      SmsTask: {},
      currentUser: {},
      taskRules: {
        //用户验证规则
        Title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        AppointNumbers: [
          { required: true, message: "请输入目标号码", trigger: "blur" }
        ],
        Content: [
          { required: true, message: "请输入发送内容", trigger: "blur" }
        ]
      },
      formLabelWidth: "120px",
      currentRole: {},//当前登录用户角色
    };
  },
  created() {
    this.getCurrentUser();
    //获取当前用户角色
    this.getCurrentRole();
    this.GetSMSTaskList();
    //获取短信条数
    //this.getSmsCount();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSMSTaskList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetSMSTaskList();
    },
    Search: function () {
      this.pageIndex = 1;
      this.GetSMSTaskList();
    },
    Refresh: function () {
      this.GetSMSTaskList();
    },
    AddTask: function () {
      if (this.currentRole.Key === "admin" || (this.currentRole.Key != "admin" && typeof this.smsCount === 'number' && this.smsCount > 0)) {
        this.dialogTitle = "添加任务";
        this.dialogVisible = true;
        this.SmsTask = {};
      }
      else {
        this.$message({
          message: '您已经没有剩余短信条数！',
          type: 'warning'
        });
      }
    },
    UpdateTask: function (row) {
      this.dialogTitle = "编辑任务";
      this.dialogVisible = true;
      GetSingleSmsTask(row.ID).then(res => {
        this.SmsTask = res;
        GetKnowledgeContentDescry(this.SmsTask.Content).then(c => {
          this.SmsTask.Content = c;
        });
      });
    },
    doTask: function (row) {
      DoTask(row).then(res => {
        var type = "success";
        if (res.Status == 2) {
          type = "warning";
        } else if (res.status == 3) {
          type = "danger";
        }
        this.$message({
          message: res.msg,
          type: type,
          center: true
        });
        this.GetSMSTaskList();
      });
    },
    doTasks: function (row) {
      GetSingleSmsTask(row.ID).then(res => {
        let sms = res;
        this.SmsTask = {};
        GetNewGuid().then(res => {
          this.SmsTask.ID = res;
          this.SmsTask.Title = sms.Title;
          this.SmsTask.AppointNumbers = sms.AppointNumbers;
          this.SmsTask.Content = sms.Content;
          this.SmsTask.AddUserID = this.currentUser.UserId;
          this.SmsTask.AddUserName = this.currentUser.TrueName;
          this.SmsTask.AddTime = new Date();
          this.SmsTask.Type = 1;
          this.SmsTask.IsRepeat = 0;
          this.SmsTask.Delay = 0;
          this.SmsTask.IsDelete = 0;
          this.SmsTask.Status = 0;
          AddSmsTask(this.SmsTask).then(msg => {
            var message = msg ? "复制成功" : "复制失败";
            if (msg) {
              this.$message({
                message: message,
                type: "success",
                center: true
              });

            } else {
              this.$message({
                message: message,
                type: "danger",
                center: true
              });
            }
            this.GetSMSTaskList();
          });
        });
      });
    },
    getCurrentUser: function () {
      this.currentUser = GetCurrentUserInfo();
    },
    //获取当前用户角色
    getCurrentRole: function () {
      var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
      this.currentRole = JSON.parse(Decrypt(currentUserRole));
    },
    DeleteTask: function (row) {
      row.IsDelete = 1;
      row.DeleteTime = new Date();
      UpdateSmsTask(row).then(res => {
        var message = res ? "删除成功" : "删除失败";
        if (res) {
          this.$message({
            message: message,
            type: "success",
            center: true
          });
        } else {
          this.$message({
            message: message,
            type: "danger",
            center: true
          });
        }
        this.GetSMSTaskList();
      });
    },
    OperSMSTask: function () {
      this.$refs["taskForm"].validate(valid => {
        if (valid) {
          if (this.SmsTask.ID) {
            EncryptContent(this.SmsTask.Content).then(res => {
              this.SmsTask.Content = res;
              UpdateSmsTask(this.SmsTask).then(msg => {
                var message = msg ? "编辑成功" : "编辑失败";
                if (msg) {
                  this.$message({
                    message: message,
                    type: "success",
                    center: true
                  });
                } else {
                  this.$message({
                    message: message,
                    type: "danger",
                    center: true
                  });
                }
                this.dialogVisible = false;
                this.GetSMSTaskList();
              });
            });
          } else {
            GetNewGuid().then(res => {
              EncryptContent(this.SmsTask.Content).then(c => {
                this.SmsTask.ID = res;
                this.SmsTask.AddUserID = this.currentUser.UserId;
                this.SmsTask.AddUserName = this.currentUser.TrueName;
                this.SmsTask.AddTime = new Date();
                this.SmsTask.Content = c;
                this.SmsTask.Type = 1;
                this.SmsTask.IsRepeat = 0;
                this.SmsTask.Delay = 0;
                this.SmsTask.IsDelete = 0;
                this.SmsTask.Status = 0;
                AddSmsTask(this.SmsTask).then(msg => {
                  var message = msg ? "添加成功" : "添加失败";
                  if (msg) {
                    this.$message({
                      message: message,
                      type: "success",
                      center: true
                    });
                  } else {
                    this.$message({
                      message: message,
                      type: "danger",
                      center: true
                    });
                  }
                  this.dialogVisible = false;
                  this.GetSMSTaskList();
                });
              });
            });
          }
        }
      });
    },
    GetSMSTaskList: function () {
      this.loading = true;
      GetSmsTaskPage(
        this.currentUser.UserId,
        this.searchName,
        this.searchNum,
        this.pageIndex,
        this.pageSize
      ).then(pageRes => {
        pageRes.DataList.forEach(element => {
          GetKnowledgeContentDescry(element.Content).then(res => {
            element.Content = res;
          });
        });
        //获取短信条数
        this.getSmsCount();
        this.SmsTaskList = pageRes.DataList;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    SmsTaskTypeFormat(row, column, cellValue, index) {
      if (cellValue == 1) {
        return "即时开始";
      } else if (cellValue == 2) {
        return "延时开始";
      } else if (cellValue == 3) {
        return "指定时间开始";
      } else {
        return "未知";
      }
    },
    isRepeatFormat(row, column, cellValue, index) {
      return this.isRepeatFormatter(cellValue);
    },
    isRepeatFormatter(value) {
      if (value == 0) {
        return "否";
      } else if (value == 1) {
        return "是";
      } else {
        return "未知";
      }
    },
    statusFormat(row, column, cellValue, index) {
      return this.statusFormatter(cellValue);
    },
    statusFormatter(value) {
      if (value == 0) {
        return "未开始";
      } else if (value == 1) {
        return "发送完成";
      } else if (value == 2) {
        return "部分发送成功";
      } else if (value == 3) {
        return "发送失败";
      } else {
        return "未知";
      }
    },
    getSmsCount: async function () {
      var count = 10000;
      var predicates = [];
      predicates.push(new Predicate("IsDelete", 0, "eq", 1));
      if (this.currentRole.Key != "admin") {
        predicates.push(new Predicate("AddUserID", this.currentUser.UserId, "eq", 1));
      }
      console.log(this.currentRole.Key)
      var successCount = 0;
      if (this.currentRole.Key != "admin") {
        await GetSmsCount(predicates).then(res => {
          res.forEach(item => {
            successCount += item.SucessCount;
          });
        });

        if (this.currentUser.PositionId == "101") {
          count = 1000 - successCount;
        } else if (this.currentUser.PositionId == "102") {
          count = 800 - successCount;
        }
        else {
          count = 500 - successCount;
        }
      }

      if (count == 10000) {
        this.smsCount = "无限";
      }
      else {
        this.smsCount = count < 0 ? 0 : count;
      }
    }
  }
};
</script>